import React, { CSSProperties } from "react";

import { Plan } from "../types";
import { formatSchemaPrice } from "../utils";
import styles from "./PlanTable.module.scss";
import TableRow from "./TableRow";

type PlanTableProps = {
  filteredPlans: Plan[];
};

const PlanTable: React.FC<PlanTableProps> = ({ filteredPlans }) => {
  return (
    <section className={styles.table} aria-labelledby="planTableTitle">
      <h2 id="planTableTitle" className={styles.tableTitle}>
        Compare plans & features
      </h2>
      <div
        className={styles.tableGrid}
        style={{ "--cols": filteredPlans.length + 1 } as CSSProperties}
        role="grid"
      >
        <div className={styles.tableHeader}>Features</div>
        {filteredPlans.map((plan) => (
          <div key={plan.id} className={styles.tableHeader}>
            {plan.name}
          </div>
        ))}

        {/* Unlimited caps arrive as null from the backend */}
        <TableRow
          label="Number of websites"
          values={filteredPlans.map(
            (plan) =>
              plan.features.find((f) => f.key === "site_max")?.value ??
              "Unlimited",
          )}
          type="number"
        />

        <TableRow
          label="Number of Team Members"
          values={filteredPlans.map(
            (plan) =>
              plan.features.find((f) => f.key === "membership_max")?.value ??
              "Unlimited",
          )}
          type="number"
        />

        <TableRow
          label="Number of Keywords"
          values={filteredPlans.map(
            (plan) =>
              plan.features.find((f) => f.key === "keyword_max")?.value ??
              "Unlimited",
          )}
          type="number"
        />

        <TableRow
          label="Number of pages"
          values={filteredPlans.map(
            (plan) =>
              plan.features.find((f) => f.key === "page_max")?.value ??
              "Unlimited",
          )}
          type="number"
        />

        <div className={styles.tableHeader}>AI Engine</div>
        {filteredPlans.map((plan) => (
          // @ts-expect-error TS2551 non-existing className
          <div key={plan.id} className={styles.table__header}>
            {plan.name}
          </div>
        ))}

        <TableRow
          label="AI JSON-LD Schemas"
          values={filteredPlans.map((plan) => {
            const addonPrice = plan.addons.defaultAddons.find(
              (a) => a.label === "schema",
            )?.price;

            return formatSchemaPrice(addonPrice);
          })}
        />

        <TableRow
          label="AI Meta descriptions"
          values={filteredPlans.map(
            (plan) =>
              plan.addons.defaultAddons.find((a) => a.label === "description")
                ?.price.tiers?.[0].up_to || 0,
          )}
          type="number"
        />

        <TableRow
          label="AI Meta titles"
          values={filteredPlans.map(
            (plan) =>
              plan.addons.defaultAddons.find((a) => a.label === "title")?.price
                .tiers?.[0].up_to || 0,
          )}
          type="number"
        />

        <TableRow
          label="Keyword rankings updates"
          values={filteredPlans.map(
            (plan) =>
              plan.addons.defaultAddons.find((a) => a.label === "update")?.price
                .tiers?.[0].up_to || 0,
          )}
          type="number"
        />

        {/*
         // @ts-expect-error TS2551 non-existing className */}
        <div className={styles.table__header}>Additional features</div>
        {filteredPlans.map((plan) => (
          // @ts-expect-error TS2551 non-existing className
          <div key={plan.id} className={styles.table__header}>
            {plan.name}
          </div>
        ))}

        <TableRow
          label="API access"
          values={filteredPlans.map(
            (plan) =>
              plan.featuresPlus.find((f) => f.key === "api_access")?.value ||
              false,
          )}
          type="check"
        />

        <TableRow
          label="Crawl interval"
          values={filteredPlans.map(
            (plan) =>
              plan.featuresPlus.find((f) => f.key === "crawl_interval")
                ?.value || "",
          )}
        />

        <TableRow
          label="Rank interval"
          values={filteredPlans.map(
            (plan) =>
              plan.featuresPlus.find((f) => f.key === "refresh_interval")
                ?.value || "",
          )}
        />
      </div>
    </section>
  );
};

export default PlanTable;
